// @ts-nocheck
import { API_FLASH_MESSAGE_LIST } from "../service/url";
import { getApiCall } from "./getApiCall";

export const fetchAndSetFlashMessage = (
  filterFn1,
  setStateFn1,
) => {
  getApiCall(API_FLASH_MESSAGE_LIST)
    .then(res => {
      const filteredMessage1 = res.filter(filterFn1);
      if (filteredMessage1.length == 1 && filteredMessage1[0]?.type === 'Flash Message') {
        setStateFn1(filteredMessage1[0]?.message ?? "");
      } else {
        setStateFn1(filteredMessage1 ?? "");
      }
    })
    .catch(err => {
      console.error("Error fetching messages:", err);
    });
};